<template>
    <!--弹窗-->
    <el-dialog
        width="70%"
        title="Sp否定投放词映射"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="formData" :model="query" :inline="true">
            <el-form-item label="店铺:" prop="name">
                <el-select v-model="query.sid" placeholder="请选择" size="mini" filterable>
                    <el-option label="全部" value=""></el-option>
                    <el-option :label="item.name" :value="item.sid" v-for="item in storeList"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="广告活动ID：" class="redItem">
                <el-input style="width: 150px" placeholder="请输入" v-model="query.campaign_id" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="广告活动：" class="redItem">
                <el-input style="width: 150px" placeholder="请输入" v-model="query.campaign_name" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="匹配类型：" class="redItem">
                <el-input style="width: 150px" placeholder="请输入" v-model="query.negative_type" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="匹配词：" class="redItem">
                <el-input style="width: 150px" placeholder="请输入" v-model="query.negative_text" size="mini"></el-input>
            </el-form-item>

            <el-button type="primary" @click="initQueryData()" size="mini" style="margin-top: 7px">查询</el-button>
            <el-button type="primary" @click="importData" size="mini" style="margin-top: 7px">导入</el-button>
        </el-form>

        <el-table
            v-loading="loading"
            :data="dataList"
            class="table_content"
            size="mini"
            height="600"
            border
            style="width: 100%;">

            <el-table-column label="店铺ID" align="center" width="80">
                <template slot-scope="scope">
                    <div>{{ scope.row.sid }}</div>
                </template>
            </el-table-column>

            <el-table-column label="店铺名称" align="center" min-width="80">
                <template slot-scope="scope">
                    <div>{{ scope.row.shopname }}</div>
                </template>
            </el-table-column>

            <el-table-column label="国家" width="80" align="center">
                <template slot-scope="scope">
                    <div>
                        <icon-svg
                            :icon-class="scope.row.country.toUpperCase()"
                            style="font-size: 24px;margin-left:5px;"
                        ></icon-svg>
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="广告活动ID" align="center" width="140">
                <template slot-scope="scope">
                    <div>{{ scope.row.campaign_id }}</div>
                </template>
            </el-table-column>
            <el-table-column label="广告活动" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.campaign_name }}</div>
                </template>
            </el-table-column>

            <el-table-column label="匹配类型" align="center" width="120" >
                <template slot-scope="scope">
                    <div>{{ scope.row.negative_type }}</div>
                </template>
            </el-table-column>

            <el-table-column label="匹配词" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.negative_text }}</div>
                </template>
            </el-table-column>

            <el-table-column label="Keyword ID" align="center"  width="140">
                <template slot-scope="scope">
                    <div>{{ scope.row.keyword_id }}</div>
                </template>
            </el-table-column>

            <el-table-column label="更新时间" align="center" width="150">
                <template slot-scope="scope">
                    <div>{{ scope.row.create_time }}</div>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"
                       :page-sizes="[10, 20, 50]" :total="query.total" background :current-page="query.page"
                       style="margin-top: 10px;display: flex;justify-content: end;"
                       layout="total, sizes, prev, pager, next">
        </el-pagination>

        <el-row style="margin-top:17px; ">
            <el-button
                style="float:right;margin-left:6px;"
                size="mini"
                type="danger"
                plain
                @click="handleClose()"
            >关 闭
            </el-button>
        </el-row>

        <upload :visible="uploadVisible" @close-callback="closeCallBack"/>
    </el-dialog>
</template>
<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import upload from './upload3.vue'

export default {
    components: {upload},
    data() {
        return {
            storeList: [],
            dataList: [],
            loading: false,
            uploadVisible: false,
            query: {
                page: 1,
                limit: 10,
                total: 0,
            },
        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        visible: {
            handler(val) {
                val && this.getStoreList()
                val && this.queryData()
            }
        },
    },
    methods: {
        getStoreList() {
            this.loading = true
            api.get_shop_lists().then(res => {
                if (res.code === 0) {
                    const responseList = res.data || []
                    this.storeList = responseList
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
                this.loading = false
            }).finally(() => {
                this.loading = false
            })
        },
        initQueryData() {
            this.query.page = 1
            this.queryData()
        },
        queryData() {
            this.loading = true
            api.negative_mapping_list({...this.query}).then(res => {
                if (res.code === 0) {
                    const responseList = res.data.list || []
                    this.dataList = responseList
                    this.query.total = res.data.total
                } else {
                    this.$message({type: 'error', message: res.message})
                }
            }).catch(() => {
                this.loading = false
            }).finally(() => {
                this.loading = false
            })
        },
        importData() {
            this.uploadVisible = true
        },
        jumpUrl(url) {
            window.open(url, '_blank')
        },
        chooseItem(data) {
            this.$emit('choose1688Info', {data: JSON.parse(JSON.stringify(data))})
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.queryData()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.queryData()
        },
        get1688List() {
            // this.loading = true
            // api.reference_index_search_ali_result({id: this.copyData.id}).then(res => {
            //     if (res.code === 0) {
            //         const responseList = res.data || []
            //         this.list = responseList
            //         this.query.total = res.data.total || 0
            //     } else {
            //         this.$message({type: 'error', message: res.message})
            //     }
            // }).catch(() => {
            //     this.loading = false
            // }).finally(() => {
            //     this.loading = false
            // })
        },
        // 关闭弹窗
        handleClose(isshow = false) {
            this.loading = false
            this.$emit('close-callback', isshow)
        },
        closeCallBack() {
            this.uploadVisible = false
            this.queryData()
        }
    }
}
</script>
<style type="text/scss" lang="scss" scoped>
.content {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #cecfd1;
    font-size: 12px;
    color: #000;

    .shu {
        border-right: 1px solid #cecfd1;
    }

    .content-div {
        width: 50%;
        padding: 25px 20px;
    }

    .content-buttom {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #cecfd1;
        padding-bottom: 8px;
        margin-bottom: 10px;
    }

    .content-buttom-txet {
        color: rgb(57, 187, 252);
        cursor: pointer;
    }

    .content-data {
        width: 100%;
        height: 230px;
        overflow: auto;

        .content-list {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0;

            .cha {
                cursor: pointer;
                font-size: 15px;
                color: rgb(158, 192, 209);
                margin: 0 10px 0 12px;
            }
        }
    }

    /deep/ .content-data::-webkit-scrollbar {
        width: 3px;
        height: 5px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-track-piece {
        background-color: #ffff;
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:vertical {
        height: 5px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }

    /deep/ .content-data::-webkit-scrollbar-thumb:horizontal {
        width: 3px;
        background-color: rgba(144, 147, 153, 0.5);
        border-radius: 15px;
        -webkit-border-radius: 15px;
    }
}

.media-txt {
    font-size: 15px;
    color: #6a6c6f;
    font-weight: 600;
    margin-bottom: 8px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px 20px 20px !important;
}

/deep/ .el-form-item {
    margin-bottom: 12px !important;
}
</style>
